export default __webpack_public_path__ + "static/media/Fifty.075bafbf.jpeg";